import useLoading from '../../control/loading/useLoading'
import useCallApi from '../../utilities/axios'
import * as umServinceURL from './umServiceURL'

export type Form = {
    email: string
    password: string
    confirmPassword: string
    nameTH: string
    nameEN: string
    telephone?: string
    reason: string
    uploadFile?: any[]
    PDPA: boolean
}
const useRegisterExternal = () => {
    const callApi = useCallApi()
    const loadingHook = useLoading()

    const post = async (values: Form) => {
        try {
            loadingHook.loadingOpen()
            const { data } = await callApi.axiosPost<any>({
                url: umServinceURL.postRegisterEx,
                params: { ...values, cunet: 0 },
            })

            return data
        } catch (err) {
        } finally {
            loadingHook.loadingClose()
        }
    }
    return { post }
}

export default useRegisterExternal
